const translation = {
  daysInWeek: {
    Sat: 'Sat',
    Thu: 'Perşembe',
    Tue: 'Salı',
    Mon: 'Mon',
    Sun: 'Güneş',
    Fri: 'Cuma',
    Wed: 'Çarşamba',
  },
  months: {
    March: 'Mart',
    December: 'Aralık',
    October: 'Ekim',
    September: 'Eylül',
    July: 'Temmuz',
    August: 'Ağustos',
    June: 'Haziran',
    November: 'Kasım',
    February: 'Şubat',
    April: 'Nisan',
    May: 'Mayıs',
    January: 'Ocak',
  },
  operation: {
    cancel: 'İptal',
    now: 'Şimdi',
    pickDate: 'Tarih Seç',
    ok: 'Tamam',
  },
  title: {
    pickTime: 'Zamanı Seç',
  },
  defaultPlaceholder: 'Bir zaman seç...',
}

export default translation
